import axios from "axios";
// import { router } from '../routes.js'

// const errorHandle = (status, msg) => {

// 	switch (status) {
// 		case 401:
// 			console.log(msg)
// 			break;
// 		case 400:
// 			break;
// 		case 404:
// 			break;
// 		case 500:
// 			break;

// 		default:
// 			console.log('攔不到錯誤QQ')
// 	}
// }

var instance = axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT,
});

instance.interceptors.request.use(
  (config) => {
    const authorization = localStorage.getItem("authorization_token");
    if (authorization) {
      config.headers.Authorization = "Bearer " + authorization;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // const { response } = error;

    // if (response) {
    // 	errorHandle(response.status, response.data.error);
    // }
    if (error.response) {
      return Promise.reject(JSON.stringify(error.response.data));
    } else {
      return Promise.reject(error);
    }
  }
);

export default function (method, url, data = null) {
  method = method.toLowerCase();

  switch (method) {
    case "get":
      // console.log("get");
      return instance.get(url, { data: data });

    case "post":
      // console.log("post");
      return instance.post(url, data);

    case "put":
      // console.log("put");
      return instance.put(url, data);

    case "patch":
      return instance.patch(url, data);

    case "delete":
      // console.log("delete");
      return instance.delete(url, { data: data });

    default:
      console.error("unknown_request_method" + method);
      return false;
  }
}
